module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: [{
        active: _vm.active
      },
      'ro-nav-item' ]
  }, [_vm._t("default"), _vm._v(" "), (_vm.children) ? _c('ro-nav-item-toggle') : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/fyrstenberg/Documents/Limbo/Roskilde-Handelsskole-Website-2023/frontend/~/vue-loader/lib/template-compiler.js?{"id":"data-v-0a899f18"}!/Users/fyrstenberg/Documents/Limbo/Roskilde-Handelsskole-Website-2023/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./scripts/ro-nav/RoNavItem.vue
// module id = 361
// module chunks = 1